import type { CaseForPharmacy } from "@omony/domain";
import type { ReactNode } from "react";
import { useT } from "../../shared/t.js";
import styles from "./flow.module.css";

export { useT } from "../../shared/t.js";

/** Ein Schritt = eine Karte mit Überschrift, Inhalt und Aktionsleiste (Primäraktion am Ende) */
export function StepFrame({
  eyebrow,
  title,
  lead,
  children,
  actions,
}: {
  eyebrow?: string;
  title: string;
  lead?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <section className={styles.step} aria-labelledby="step-title">
      <div className={styles.stepHead}>
        {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
        <h1 id="step-title" className={styles.title} tabIndex={-1}>
          {title}
        </h1>
        {lead ? <p className={styles.lead}>{lead}</p> : null}
      </div>
      {children}
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </section>
  );
}

export const Spacer = () => <span className={styles.spacer} />;

/** Anzeige-Label der Patientin / des Patienten (anonym: Initialen + Alter) */
export function useCaseLabel() {
  const t = useT();
  return (c: Pick<CaseForPharmacy, "label">) =>
    c.label.initials
      ? c.label.age !== null
        ? t("console.case.labelAge", { initials: c.label.initials, age: c.label.age })
        : c.label.initials
      : t("console.case.noPatient");
}

export const euro = (cents: number, locale: string) =>
  new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" }).format(cents / 100);
